<template>
  <div class="clauserow" style="margin-left: 10px;">
    <div class="clauserowheader">
      <div class="text-block-4">{{clause.name}}</div>
      <a href="#" @click="$emit('sharePressed', clause)" class="link-block w-inline-block"
        ><img src="static/images/back-arrow.png" alt="" class="image-2"
      /></a>
    </div>
    <div class="clauserowbody">
      <div class="text-block-4">
        {{truncatedText}}
      </div>
    </div>
  </div>
</template>

<script>
import clausemixin from './mixins/clause.mixin'
export default {
  mixins: [clausemixin]
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/OverviewClauseItem.vue